


import * as Actions from '../actions';

const initialState = {
    isLoading: true,
    errMsg: null,
    data: []
    };


// get active categories
export const allCasesCounterReducer = function(state = initialState, action) {
switch (action.type) {
case Actions.ALL_CUSTOMER_CASES_COUNTERT:
return { ...state, isLoading: false, errMsg: null, data: action.payload };
case Actions.ALL_CUSTOMER_CASES_COUNTERT_LOADING:
return { ...state, isLoading: true, errMsg: null, data: [] };
case Actions.ALL_CUSTOMER_CASES_COUNTERT_LOADING_FAILED:
return { ...state, isLoading: false, errMsg: action.payload, data: [] };
default:
return state;
}
};
